import DialogFooter from 'components/actions/DialogFooter';
import NoData from 'components/content/NoData';
import Dialog from 'components/overlays/Dialog';
import type { UserFE } from 'domain/systemAdmin';
import { SystemAdminDialogTypes } from 'helper/types';
import { useSelector } from 'react-redux';
import { getActiveUser, getSystemAdminOpenDialog } from 'store/slices/settingsPageSlice';

import { getUserFullName } from './utils';

import './styles/ResetPasswordDialog.scss';

interface TitleProps {
    user?: UserFE;
}

const Title = ({ user }: TitleProps) => {
    const fullName = getUserFullName(user);

    return (
        <p className='ResetPasswordDialog__text--title'>
            Are you sure you want to reset&nbsp;
            <span className='ResetPasswordDialog__text--bold'>{fullName ?? <NoData />}</span>
            &apos;s password?
        </p>
    );
};

const Body = () => (
    <div className='ResetPasswordDialog__body'>
        <span className='rioglyph rioglyph-key ResetPasswordDialog__icon' />
        <p className='ResetPasswordDialog__text ResetPasswordDialog__text--body'>
            The user will receive an email with instructions to set a new password.
        </p>
    </div>
);

interface Props {
    onConfirm: () => void;
    onCancel: () => void;
    isLoading?: boolean;
}

const ResetPasswordDialog = ({ onConfirm, onCancel, isLoading }: Props) => {
    const systemAdminOpenDialog = useSelector(getSystemAdminOpenDialog);
    const show = systemAdminOpenDialog === SystemAdminDialogTypes.RESET_PASSWORD_DIALOG;
    const activeUser = useSelector(getActiveUser);

    return (
        <Dialog
            data-testid='system-users-dialog-reset-password'
            show={show}
            title={<Title user={activeUser} />}
            body={<Body />}
            footer={
                <DialogFooter
                    id='reset-password'
                    submitLabel='Yes, reset password'
                    onSubmit={onConfirm}
                    cancelLabel='No, cancel'
                    onCancel={onCancel}
                    style='danger'
                    isLoading={isLoading}
                />
            }
            size='sm'
            onClose={onCancel}
            showCloseButton
        />
    );
};

export default ResetPasswordDialog;
